var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgArchiveOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 5.41602C5.51117 5.41602 5.25 5.67718 5.25 5.99935C5.25 6.32152 5.51117 6.58268 5.83333 6.58268H8.16667C8.48883 6.58268 8.75 6.32152 8.75 5.99935C8.75 5.67718 8.48883 5.41602 8.16667 5.41602H5.83333Z",
    fill: "var(--red-5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.749349C0 0.427183 0.261167 0.166016 0.583333 0.166016H13.4167C13.7388 0.166016 14 0.427183 14 0.749349V3.66602C14 3.98818 13.7388 4.24935 13.4167 4.24935H12.8333V11.2493C12.8333 11.5715 12.5722 11.8327 12.25 11.8327H1.75C1.42783 11.8327 1.16667 11.5715 1.16667 11.2493V4.24935H0.583333C0.261167 4.24935 0 3.98818 0 3.66602V0.749349ZM11.6667 10.666V4.24935H2.33333V10.666H11.6667ZM12.8333 3.08268H1.16667V1.33268H12.8333V3.08268Z",
    fill: "var(--red-5)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveOutlined);
export default __webpack_public_path__ + "static/media/archiveOutlined.0d659ef3eeab6f8c81b10d785f83ebbf.svg";
export { ForwardRef as ReactComponent };